import {
	SEVERITY_LABEL,
	getSeverityLabel,
	TShipmentNoteSubCategory,
	TShipmentNoteCategory,
	NOTE_CATEGORY,
	TNotesForm
} from '@types';

export const radioOptions = [
	{ value: 'NEW', label: 'New' },
	{ value: 'OPEN', label: 'Open' },
	{ value: 'CLOSED', label: 'Closed' },
];

export const severityOptions = [
	...Object.keys(SEVERITY_LABEL).map((severity) => {
		const title = getSeverityLabel(severity as SEVERITY_LABEL);
		return { label: title, value: severity };
	})
];

export const GetSubCats = (props: { subCategories: TShipmentNoteSubCategory[]; form: TNotesForm; isNew: boolean }) => {
	const { subCategories, form, isNew } = props;
	return subCategories.filter((cat) => {
		return isNew ? cat.note_category === form.category && cat.can_create : cat.note_category === form.category;
	});
}

// A grouped option is a sub-category, so the category it belongs to has to be resolved from the
// group it was picked from. Falling back to the sub-category's own category — and ignoring a value
// that matches nothing at all — stops a selection being wiped when the loaded categories and the
// picked option don't line up.
export const ResolveCategorySelection = (props: {
	value: string;
	groups?: string[];
	categories: TShipmentNoteCategory[];
	subCategories: TShipmentNoteSubCategory[];
	isNew: boolean;
}) => {
	const { value, groups, categories, subCategories, isNew } = props;
	const groupLabel = groups?.[0];
	const categoryFromGroup = groupLabel
		? categories.find((category) => category.label === groupLabel)?.value
		: undefined;
	if (categoryFromGroup) return { category: categoryFromGroup, subCategory: value };
	const subCategory = subCategories.find((sub) => sub.value === value && (isNew ? sub.can_create : sub.can_edit));
	if (subCategory) return { category: subCategory.note_category, subCategory: subCategory.value };
	if (categories.some((category) => category.value === value)) return { category: value, subCategory: '' };
	return null;
}

export const HasCarrierOpts = (props: { categories: TShipmentNoteCategory[]; carrierOptions: any; isEdit: boolean; form: TNotesForm }) => {
	const { categories, carrierOptions, isEdit, form } = props;
	const currCategory = categories.find((category) => category.value === form.category);
	if (!isEdit && carrierOptions?.length > 1 && currCategory?.has_carrier_options) {
		return true;
	}
	if (isEdit && carrierOptions?.length > 1 && form.carrierId) {
		return true;
	}
	return false;
}

export const CategoryNameFromVal = (props: { category: NOTE_CATEGORY; categories: TShipmentNoteCategory[] }) => {
	const { category, categories } = props;
	const found = categories.find((cat) => cat.value === category);
	if (found) {
		return found.label;
	}
	return '';
}

export const defaultForm = {
	category: '',
	subCategory: '',
	note: '',
	shipperCanSee: false,
	carrierId: '',
	dateOfIncident: '',
	severityOfIncident: '',
	statusOfIncident: 'NEW'
}
